import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
// eslint-disable-next-line import/no-unassigned-import -- global stylesheet side-effect import
import "./index.css";
import { bootstrapLanguage } from "./i18n/diner-language";
import { createWidgetQueryClient, WidgetProviders } from "./providers";
import { router } from "./router";
import { startEmbedBridge } from "./embed/start";

/**
 * Standalone / iframe entry. Resolves the diner language BEFORE first paint (localization-i18n R1),
 * mounts the app, then starts the in-iframe resize bridge (no-op when not framed).
 */
const params = new URLSearchParams(window.location.search);
const browser = navigator.languages ?? [navigator.language];

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

const client = createWidgetQueryClient();

void bootstrapLanguage(params.get("lang"), browser).finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <WidgetProviders client={client}>
        <RouterProvider router={router} />
      </WidgetProviders>
    </StrictMode>,
  );
  startEmbedBridge();
});
